import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ImageIcon, Sparkles, ArrowRight, Shuffle } from 'lucide-react'
import { cn } from '@/lib/utils'
import { getRandomPrompt } from '@/lib/prompt-suggestions'

export function HomeGenerateSection() {
  const navigate = useNavigate()

  const [prompt, setPrompt] = useState('')

  const handleGenerate = () => {
    const trimmedPrompt = prompt.trim()
    if (!trimmedPrompt) return

    navigate(`/images/t2i?prompt=${encodeURIComponent(trimmedPrompt)}`)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleGenerate()
    }
  }

  return (
    <>
      <div className="w-full space-y-3">
        <div className="relative rounded-2xl p-[1px] bg-gradient-to-br from-white/[0.15] via-white/[0.05] to-white/[0.1]">
          <div className="relative rounded-2xl bg-[#0a0a0a] overflow-hidden">
            <div className="flex items-start gap-3 p-4">
              <Sparkles className="size-5 text-[#666] mt-1 shrink-0" />
              <textarea
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Describe the image you want to create..."
                rows={3}
                className={cn(
                  'flex-1 bg-transparent text-white text-sm placeholder:text-[#555] resize-none outline-none',
                  'leading-relaxed'
                )}
              />
            </div>
            <div className="flex items-center justify-between px-4 pb-3 gap-3">
              <button
                type="button"
                onClick={() => setPrompt(getRandomPrompt())}
                className="flex items-center gap-1.5 text-xs text-[#666] hover:text-white transition-colors shrink-0"
              >
                <Shuffle className="size-3.5" />
                Surprise me
              </button>
              <button
                onClick={handleGenerate}
                disabled={!prompt.trim()}
                className={cn(
                  'flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-medium transition-all shrink-0',
                  prompt.trim()
                    ? 'bg-white text-black hover:bg-white/90 active:scale-[0.98]'
                    : 'bg-white/[0.06] text-[#555] cursor-not-allowed'
                )}
              >
                <ImageIcon className="size-4" />
                Generate
                <ArrowRight className="size-3.5" />
              </button>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}
